export default [
  {
    value: "Agriculture, Horticulture & Livestock",
    label: "Agriculture, Horticulture & Livestock"
  },
  {
    value: "Banking, Insurance & Financial Services",
    label: "Banking, Insurance & Financial Services"
  },
  {
    value: "Biotechnology and Life Sciences",
    label: "Biotechnology and Life Sciences"
  },
  { value: "Business Services", label: "Business Services" },
  {
    value: "Chemicals, Petroleum, Rubber & Plastic",
    label: "Chemicals, Petroleum, Rubber & Plastic"
  },
  { value: "Communications", label: "Communications" },
  { value: "Computer Hardware", label: "Computer Hardware" },
  { value: "Computer Software", label: "Computer Software" },
  { value: "Construction", label: "Construction" },
  {
    value: "Food & Tobacco Manufacturing",
    label: "Food & Tobacco Manufacturing"
  },
  {
    value: "Industrial, Electric & Electronic Machinery",
    label: "Industrial, Electric & Electronic Machinery"
  },
  { value: "Information Services", label: "Information Services" },
  {
    value: "Leather, Stone, Clay & Glass products",
    label: "Leather, Stone, Clay & Glass products"
  },
  { value: "Media & Broadcasting", label: "Media & Broadcasting" },
  { value: "Metals & Metal Products", label: "Metals & Metal Products" },
  { value: "Mining & Extraction", label: "Mining & Extraction" },
  {
    value: "Miscellaneous Manufacturing",
    label: "Miscellaneous Manufacturing"
  },
  { value: "Printing & Publishing", label: "Printing & Publishing" },
  { value: "Property Services", label: "Property Services" },
  {
    value: "Public Administration, Education, Health Social Services",
    label: "Public Administration, Education, Health Social Services"
  },
  { value: "Retail", label: "Retail" },
  {
    value: "Textiles & Clothing Manufacturing",
    label: "Textiles & Clothing Manufacturing"
  },
  { value: "Transport Manufacturing", label: "Transport Manufacturing" },
  {
    value: "Transport, Freight & Storage",
    label: "Transport, Freight & Storage"
  },
  {
    value: "Travel, Personal & Leisure",
    label: "Travel, Personal & Leisure"
  },
  { value: "Utilities", label: "Utilities" },
  {
    value: "Waste Management & Treatment",
    label: "Waste Management & Treatment"
  },
  { value: "Wholesale", label: "Wholesale" },
  {
    value: "Wood, Furniture & Paper Manufacturing",
    label: "Wood, Furniture & Paper Manufacturing"
  },
  {
    value: "Other",
    label: "Other"
  }
];



// WEBPACK FOOTER //
// ./src/createEntityModal/industries.ts